/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/

import { atom } from "jotai";
import { BaseService } from "@/frameworks/libraries/restservice";

// class UserAdminGroup extends BaseService {
// 	constructor() {
// 		super();

// 		this.initialize();
// 	}

// 	private APIPath = (groupId: string, path?: string) => `/api/admin/groups/${groupId}${path ? `/${path}` : ""}`;

// 	private static Cache = {
// 		Delete: atom<WebServices.UserAdmin.Group.Delete.Response>({}),
// 		Options: atom<WebServices.UserAdmin.Group.Options.Response>({}),
// 		Inquiry: atom<WebServices.UserAdmin.Group.Inquiry.Response>({}),
// 		Roles: atom<WebServices.UserAdmin.Group.Roles.Response>({}),
// 		OptionUpdate: atom<WebServices.UserAdmin.Group.OptionUpdate.Response>({})
// 	};

// 	public deleteGroup = (name: string, events: API.Events) => ({
// 		name,
// 		events,
// 		callback: ({ groupId }: WebServices.UserAdmin.Group.Delete.Request) => this.delete(this.APIPath(groupId)),
// 		cache: UserAdminGroup.Cache.Delete
// 	});

// 	public options = (name: string, events: API.Events) => ({
// 		name,
// 		events,
// 		callback: ({ groupId }: WebServices.UserAdmin.Group.Options.Request) =>
// 			this.get(this.APIPath(groupId, "options")),
// 		cache: UserAdminGroup.Cache.Options
// 	});

// 	public inquiry = (name: string, events: API.Events) => ({
// 		name,
// 		events,
// 		callback: ({ groupId }: WebServices.UserAdmin.Group.Inquiry.Request) => this.get(this.APIPath(groupId)),
// 		cache: UserAdminGroup.Cache.Inquiry
// 	});

// 	public roles = (name: string, events: API.Events) => ({
// 		name,
// 		events,
// 		callback: ({ groupId }: WebServices.UserAdmin.Group.Roles.Request) => this.get(this.APIPath(groupId, "roles")),
// 		cache: UserAdminGroup.Cache.Roles
// 	});

// 	public optionUpdate = (name: string, events: API.Events) => ({
// 		name,
// 		events,
// 		callback: ({ groupId, ...rest }: WebServices.UserAdmin.Group.OptionUpdate.Request) =>
// 			this.put(this.APIPath(groupId, "options"), rest),
// 		cache: UserAdminGroup.Cache.OptionUpdate
// 	});
// }

// class UserAdminGroupUser extends BaseService {
// 	constructor() {
// 		super();

// 		this.initialize();
// 	}

// 	private APIPath = (groupId: string, path?: string) =>
// 		`/api/admin/groups/${groupId}/group_users${path ? `/${path}` : ""}`;

// 	private static Cache = {
// 		Inquiry: atom<WebServices.UserAdmin.GroupUser.Inquiry.Response>({}),
// 		Add: atom<WebServices.UserAdmin.GroupUser.Add.Response>({}),
// 		Unlock: atom<WebServices.UserAdmin.GroupUser.Unlock.Response>({}),
// 		ResendAuthenticationEmail: atom<WebServices.UserAdmin.GroupUser.ResendAuthenticationEmail.Response>({}),
// 		ImportUser: atom<WebServices.UserAdmin.GroupUser.ImportUser.Response>({}),
// 		EmailCheck: atom<WebServices.UserAdmin.GroupUser.EmailCheck.Response>({})
// 		// GroupUpdate: atom<WebServices.UserAdmin.GroupUser.GroupUpdate.Response>({})
// 	};

// 	public inquiry = (name: string, events: API.Events) => ({
// 		name,
// 		events,
// 		callback: ({ groupId, userId }: WebServices.UserAdmin.GroupUser.Inquiry.Request) =>
// 			this.get(this.APIPath(groupId, userId)),
// 		cache: UserAdminGroupUser.Cache.Inquiry
// 	});

// 	public add = (name: string, events: API.Events) => ({
// 		name,
// 		events,
// 		callback: ({ groupId, ...rest }: WebServices.UserAdmin.GroupUser.Add.Request) =>
// 			this.post(this.APIPath(groupId), rest),
// 		cache: UserAdminGroupUser.Cache.Add
// 	});

// 	public unlock = (name: string, events: API.Events) => ({
// 		name,
// 		events,
// 		callback: ({ groupId, ...rest }: WebServices.UserAdmin.GroupUser.Unlock.Request) =>
// 			this.post(this.APIPath(groupId, "unlock"), rest),
// 		cache: UserAdminGroupUser.Cache.Unlock
// 	});

// 	public resendAuthenticationEmail = (name: string, events: API.Events) => ({
// 		name,
// 		events,
// 		callback: ({ groupId, ...rest }: WebServices.UserAdmin.GroupUser.ResendAuthenticationEmail.Request) =>
// 			this.post(this.APIPath(groupId, "resend_authentication_email"), rest),
// 		cache: UserAdminGroupUser.Cache.ResendAuthenticationEmail
// 	});

// 	public importUser = (name: string, events: API.Events) => ({
// 		name,
// 		events,
// 		callback: ({ groupId, ...rest }: WebServices.UserAdmin.GroupUser.ImportUser.Request) =>
// 			this.post(this.APIPath(groupId, "excel_import"), rest, {
// 				headers: { "Content-Type": "multipart/form-data" }
// 			}),
// 		cache: UserAdminGroupUser.Cache.ImportUser
// 	});

// 	public emailCheck = (name: string, events: API.Events) => ({
// 		name,
// 		events,
// 		callback: ({ groupId, ...rest }: WebServices.UserAdmin.GroupUser.EmailCheck.Request) =>
// 			this.post(this.APIPath(groupId, "email_check"), rest),
// 		cache: UserAdminGroupUser.Cache.EmailCheck
// 	});

// 	public groupUpdate = (name: string, events: API.Events) => ({
// 		name,
// 		events,
// 		callback: ({ groupId, userId, ...rest }: WebServices.UserAdmin.GroupUser.GroupUpdate.Request) =>
// 			this.put(this.APIPath(groupId, userId), rest),
// 		cache: UserAdminGroupUser.Cache.GroupUpdate
// 	});
// }

class Group extends BaseService {
	constructor() {
		super();
	}

	private APIPath = (groupId?: string, path?: string) =>
		`/api/groups${groupId ? `/${groupId}` : ""}${path ? `/${path}` : ""}`;

	private static Cache = {
		Delete: atom<WebServices.Group.Delete.Response>({}),
		Inquiry: atom<WebServices.Group.Inquiry.Response>({}),
		InquiryWOAuth: atom<WebServices.Group.Inquiry.InquiryWOAuth.Response>({}),
		Create: atom<WebServices.Group.Create.Response>({}),
		Update: atom<WebServices.Group.Update.Response>({}),
		Authorities: atom<WebServices.Group.Authorities.Response>({}),
		AuthoritieList: atom<WebServices.Group.AuthoritieList.Response>({}),
		Search: atom<WebServices.Group.Search.Response>({}),
		AllowTypes: atom<WebServices.Group.Search.AllowTypes.Response>({}),
		join: {
			List: atom<WebServices.Group.Join.List.Response>({}),
			Request: atom<WebServices.Group.Join.Request.Response>({}),
			Process: atom<WebServices.Group.Join.Process.Response>({}),
			Status: atom<WebServices.Group.Join.Status.Response>({}),
			Cancel: atom<WebServices.Group.Join.Cancel.Response>({})
		},
		Domain: {
			Status: atom<WebServices.Group.Domain.Status.Response>({})
		},
		Role: atom<WebServices.Group.Role.Response>({}),
		Joined: {
			Users: atom<WebServices.Group.Joined.Users.Response>({}),
			Groups: atom<WebServices.Group.Joined.Groups.Response>({})
		},
		SpaceList: atom<WebServices.Group.SpaceList.Response>({})
	};

	public deleteGroup = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId }: WebServices.Group.Delete.Request) => this.delete(this.APIPath(groupId)),
		cache: Group.Cache.Delete
	});

	public inquiry = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId }: WebServices.Group.Inquiry.Request) => this.get(this.APIPath(groupId)),
		cache: Group.Cache.Inquiry
	});

	public inquiryWOAuth = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId }: WebServices.Group.Inquiry.InquiryWOAuth.Request) =>
			this.get(this.APIPath(groupId, "simple")),
		cache: Group.Cache.InquiryWOAuth
	});

	public create = (name: string, events: API.Events) => ({
		name,
		events,
		callback: (parameter: WebServices.Group.Create.Request) =>
			this.post(this.APIPath(), parameter, {
				headers: { "Content-Type": "multipart/form-data" }
			}),
		cache: Group.Cache.Create
	});

	public update = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId, ...rest }: WebServices.Group.Update.Request) =>
			this.post(this.APIPath(groupId), rest, {
				headers: { "Content-Type": "multipart/form-data" }
			}),
		cache: Group.Cache.Update
	});

	public authorities = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId }: WebServices.Group.Authorities.Request) =>
			this.post(this.APIPath(groupId, `authorities`)),
		cache: Group.Cache.Authorities
	});

	public authoritieList = (name: string, events: API.Events) => ({
		name,
		events,
		callback: (parameter: WebServices.Group.AuthoritieList.Request) =>
			this.get(this.APIPath("supported_authorities"), parameter),
		cache: Group.Cache.AuthoritieList
	});

	public search = (name: string, events: API.Events) => ({
		name,
		events,
		callback: (parameter: WebServices.Group.Search.Request) => this.get(this.APIPath(), parameter),
		cache: Group.Cache.Search
	});

	public searchAllowTypes = (name: string, events: API.Events) => ({
		name,
		events,
		callback: (parameter: WebServices.Group.Search.AllowTypes.Request) =>
			this.get(this.APIPath("search_allow_types"), parameter),
		cache: Group.Cache.AllowTypes
	});

	public join = {
		list: (name: string, events: API.Events) => ({
			name,
			events,
			callback: ({ groupId }: WebServices.Group.Join.List.Request) =>
				this.get(this.APIPath(groupId, "join_requests")),
			cache: Group.Cache.join.List
		}),
		request: (name: string, events: API.Events) => ({
			name,
			events,
			callback: ({ groupId }: WebServices.Group.Join.Request.Request) =>
				this.post(this.APIPath(groupId, "join_requests")),
			cache: Group.Cache.join.Request
		}),
		process: (name: string, events: API.Events) => ({
			name,
			events,
			callback: ({ groupId, ...rest }: WebServices.Group.Join.Process.Request) =>
				this.post(this.APIPath(groupId, "join_requests/process"), rest),
			cache: Group.Cache.join.Process
		}),
		status: (name: string, events: API.Events) => ({
			name,
			events,
			callback: ({ groupId }: WebServices.Group.Join.Status.Request) =>
				this.get(this.APIPath(groupId, "join_status")),
			cache: Group.Cache.join.Status
		}),
		cancel: (name: string, events: API.Events) => ({
			name,
			events,
			callback: ({ groupId }: WebServices.Group.Join.Cancel.Request) =>
				this.delete(this.APIPath(groupId, "join_requests")),
			cache: Group.Cache.join.Cancel
		})
	};

	public role = (name: string, events: API.Events) => ({
		name,
		events,
		callback: (parameter: WebServices.Group.Role.Request) => this.get(this.APIPath("roles"), parameter),
		cache: Group.Cache.Role
	});

	public domain = {
		status: (name: string, events: API.Events) => ({
			name,
			events,
			callback: ({ groupId }: WebServices.Group.Domain.Status.Request) =>
				this.get(this.APIPath(groupId, "domain_option_check")),
			cache: Group.Cache.Domain.Status
		})
	};

	public joined = {
		users: (name: string, events: API.Events) => ({
			name,
			events,
			callback: (parameter: WebServices.Group.Joined.Users.Request) =>
				this.get(this.APIPath("joined_users"), parameter),
			cache: Group.Cache.Joined.Users
		}),
		groups: (name: string, events: API.Events) => ({
			name,
			events,
			callback: (parameter: WebServices.Group.Joined.Groups.Request) =>
				this.get(this.APIPath("joined_groups"), parameter),
			cache: Group.Cache.Joined.Groups
		})
	};

	public spaceList = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId, ...parameter }: WebServices.Group.SpaceList.Request) =>
			this.get(this.APIPath(groupId, "spaces"), parameter),
		cache: Group.Cache.SpaceList
	});
}

class GroupAuthenticationEmail extends BaseService {
	constructor() {
		super();
	}

	private APIPath = (id?: string) => `/api/group_authentication_email${id ? `/${id}` : ""}`;

	private static Cache = {
		Inquiry: atom<WebServices.GroupAuthenticationEmail.Inquiry.Response>({}),
		Authenticate: atom<WebServices.GroupAuthenticationEmail.Authenticate.Response>({})
	};

	public inquiry = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ id }: WebServices.GroupAuthenticationEmail.Inquiry.Request) => this.get(this.APIPath(id)),
		cache: GroupAuthenticationEmail.Cache.Inquiry
	});

	public authenticate = (name: string, events: API.Events) => ({
		name,
		events,
		callback: (parameter: WebServices.GroupAuthenticationEmail.Authenticate.Request) =>
			this.post(this.APIPath("authenticate"), parameter),
		cache: GroupAuthenticationEmail.Cache.Authenticate
	});
}

class GroupInvite extends BaseService {
	constructor() {
		super();
	}

	private APIPath = (groupId: string, path?: string) => `/api/groups/${groupId}${path ? `/${path}` : ""}`;
	private InviteAPIPath = (groupId: string, path?: string) =>
		`/api/group_invite_emails/${groupId}${path ? `/${path}` : ""}`;

	private static Cache = {
		Cancel: atom<WebServices.GroupInvite.Cancel.Response>({}),
		List: atom<WebServices.GroupInvite.List.Response>({}),
		Inquiry: atom<WebServices.GroupInvite.Inquiry.Response>({}),
		Invite: atom<WebServices.GroupInvite.Invite.Response>({}),
		Process: atom<WebServices.GroupInvite.Process.Response>({})
	};

	public cancel = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId, ...rest }: WebServices.GroupInvite.Cancel.Request) =>
			this.delete(this.APIPath(groupId, "invite"), rest),
		cache: GroupInvite.Cache.Cancel
	});

	public list = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId }: WebServices.GroupInvite.List.Request) => this.get(this.APIPath(groupId, "invite")),
		cache: GroupInvite.Cache.List
	});

	public inquiry = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ id }: WebServices.GroupInvite.Inquiry.Request) => this.get(this.InviteAPIPath(id)),
		cache: GroupInvite.Cache.Inquiry
	});

	public invite = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId, ...rest }: WebServices.GroupInvite.Invite.Request) =>
			this.post(this.APIPath(groupId, "invite"), rest),
		cache: GroupInvite.Cache.Invite
	});

	public process = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId, ...rest }: WebServices.GroupInvite.Process.Request) =>
			this.post(this.APIPath(groupId, "invite/process"), rest),
		cache: GroupInvite.Cache.Process
	});
}

class GroupKeyword extends BaseService {
	constructor() {
		super();
	}

	private APIPath = (groupId: string, keywordId: string) => `/api/groups/${groupId}/keywords/${keywordId}`;

	private static Cache = {
		Delete: atom<WebServices.GroupKeyword.Delete.Response>({})
	};

	public deleteKeyword = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId, keywordId }: WebServices.GroupKeyword.Delete.Request) =>
			this.delete(this.APIPath(groupId, keywordId)),
		cache: GroupKeyword.Cache.Delete
	});
}

class GroupRecommend extends BaseService {
	constructor() {
		super();
	}

	private APIPath = (path?: string) => `/api/groups/recommends${path ? `/${path}` : ""}`;

	private static Cache = {
		List: atom<WebServices.GroupRecommend.List.Response>({})
	};

	public list = (name: string, events: API.Events) => ({
		name,
		events,
		callback: (parameter: WebServices.GroupRecommend.List.Request) => this.get(this.APIPath(), parameter),
		cache: GroupRecommend.Cache.List
	});
}

class GroupUser extends BaseService {
	constructor() {
		super();
	}

	private APIPath = (groupId: string, path?: string) => `/api/groups/${groupId}/group_users${path ? `/${path}` : ""}`;

	private static Cache = {
		Leave: atom<WebServices.GroupUser.Leave.Response>({}),
		CancelLeave: atom<WebServices.GroupUser.CancelLeave.Response>({}),
		Delete: atom<WebServices.GroupUser.Delete.Response>({}),
		List: atom<WebServices.GroupUser.List.Response>({}),
		LeaveRequestList: atom<WebServices.GroupUser.LeaveRequestList.Response>({}),
		CheckLeave: atom<WebServices.GroupUser.CheckLeave.Response>({}),
		Process: atom<WebServices.GroupUser.Process.Response>({}),
		Appointment: atom<WebServices.GroupUser.Appointment.Response>({}),
		JoinStatus: atom<WebServices.GroupUser.JoinStatus.Response>({})
	};

	public leave = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId }: WebServices.GroupUser.Leave.Request) => this.delete(this.APIPath(groupId)),
		cache: GroupUser.Cache.Leave
	});

	public cancelLeave = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId }: WebServices.GroupUser.CancelLeave.Request) =>
			this.delete(this.APIPath(groupId, "delete_requests")),
		cache: GroupUser.Cache.CancelLeave
	});

	public deleteMember = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId, userId }: WebServices.GroupUser.Delete.Request) =>
			this.delete(this.APIPath(groupId, userId)),
		cache: GroupUser.Cache.Delete
	});

	public list = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId }: WebServices.GroupUser.List.Request) => this.get(this.APIPath(groupId)),
		cache: GroupUser.Cache.List
	});

	public leaveRequestList = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId }: WebServices.GroupUser.LeaveRequestList.Request) =>
			this.get(this.APIPath(groupId, "delete_requests")),
		cache: GroupUser.Cache.LeaveRequestList
	});

	public isLeaveAvailable = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId }: WebServices.GroupUser.CheckLeave.Request) =>
			this.get(this.APIPath(groupId, "delete_check")),
		cache: GroupUser.Cache.CheckLeave
	});

	public process = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId, ...rest }: WebServices.GroupUser.Process.Request) =>
			this.post(this.APIPath(groupId, "delete_requests/process"), rest),
		cache: GroupUser.Cache.Process
	});

	public appointment = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId, ...rest }: WebServices.GroupUser.Appointment.Request) =>
			this.put(this.APIPath(groupId, "admin"), rest),
		cache: GroupUser.Cache.Appointment
	});

	public joinStatus = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId, userId }: WebServices.GroupUser.JoinStatus.Request) =>
			this.get(this.APIPath(groupId, userId + "/join_status")),
		cache: GroupUser.Cache.JoinStatus
	});
}

class GroupServiceStatic {
	constructor(
		public readonly userAdmin = {
			// group: new UserAdminGroup(),
			// groupUser: new UserAdminGroupUser()
		},
		public readonly group = new Group(),
		public readonly groupAuthenticationEmail = new GroupAuthenticationEmail(),
		public readonly groupInvite = new GroupInvite(),
		public readonly groupKeyword = new GroupKeyword(),
		public readonly groupRecommends = new GroupRecommend(),
		public readonly groupUser = new GroupUser()
	) {}
}
const GroupService = new GroupServiceStatic();
export default GroupService;
